import { Locale, type LocalizedString } from "../Locale.js";

export const serviceInspectionPathMap = {
	[Locale.cs]: "inspekce-skladu" as const,
} satisfies LocalizedString;
